export const loadAuthorizeScript = () => {
    return new Promise((resolve) => {
      if (document.getElementById("authorize-script")) return resolve();
  
      const script = document.createElement("script");
  
      script.src =
        process.env.NODE_ENV === "production"
          ? "https://jstest.authorize.net/v1/Accept.js"      // LIVE
          : "https://jstest.authorize.net/v1/Accept.js"; // SANDBOX
  
      script.type = "text/javascript";
      script.id = "authorize-script";
      script.onload = resolve;
  
      document.body.appendChild(script);
    });
  };
  